// Wording for the Data screens, over what GET /api/datasets returns
// (lib/dataset_pages.js).

// "175 responses", or "statistics unavailable" when the summary is missing.
export const amount = (dataset) => dataset.records === null ? 'statistics unavailable'
  : `${dataset.records} ${dataset.unit ?? 'records'}`;

export const periodRange = (periods) => !periods.length ? '—'
  : periods.length === 1 ? periods[0] : `${periods[0]} – ${periods.at(-1)}`;

// Where a source's latest export stands, as the Overview words it.
// A watermark as read: a snapshot source's is the moment it was last read
// (an ISO timestamp), shown as a date and time; another's is the latest
// timestamp in its export, shown as the export writes it.
export const watermarkText = (watermark) => /^\d{4}-\d\d-\d\dT/.test(watermark ?? '')
  ? new Date(watermark).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : watermark;

export const exportState = (source) => source.mode === null ? 'statistics unavailable'
  : source.mode === 'awaiting-upload' ? 'waiting for its first file'
  : source.mode === 'snapshot' ? (source.watermark ? `checked ${watermarkText(source.watermark)}` : 'not checked')
  : source.pending ? `${source.pending} new rows waiting` : 'up to date';

// A term in the dataset's own words (a survey's question), for naming what a
// cube counts.
export const termText = (dataset, id) => dataset.terms.flatMap((section) => section.terms)
  .find((term) => term.id === id)?.text ?? id;
